<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <div class="header-welcome">
      <div class="welcome-text">
        <h1>Welcome, {{ userName }}! 👋</h1>
        <p>Smarter hiring starts here</p>
      </div>
      <div class="header-filter">
        <div class="modern-dropdown" [class.open]="showTimeFilter">
          <button class="dropdown-trigger" (click)="showTimeFilter = !showTimeFilter">
            <span>{{ getTimeFilterLabel() }}</span>
            <i class="pi pi-chevron-down" [class.rotated]="showTimeFilter"></i>
          </button>
          <div class="dropdown-menu" *ngIf="showTimeFilter">
            <button *ngFor="let option of timeOptions" class="dropdown-item"
              [class.active]="timeFilter === option.value"
              (click)="timeFilter = option.value; showTimeFilter = false; loadData()">
              <span>{{ option.label }}</span>
              <i class="pi pi-check" *ngIf="timeFilter === option.value"></i>
            </button>
          </div>
        </div>

        <div (click)="dashboardLogoutPanel.toggle($event)" class="user-profile" tabindex="0" role="button">
          <div class="user-avatar-wrapper">
            <div class="user-initials" *ngIf="userMeta$ | async as userMeta">
              {{getUserInitials(userMeta.user_profile)}}
            </div>
          </div>
        </div>

        <p-popover #dashboardLogoutPanel styleClass="profile-overlay">
          <div class="profile-dropdown">
            <div class="user-details-section" *ngIf="userMeta$ | async as userMeta">
              <div class="user-avatar-large">
                <div class="user-initials-large">{{getUserInitials(userMeta.user_profile)}}</div>
              </div>
              <div class="user-details">
                <h4 class="user-full-name">{{getFullName(userMeta.user_profile)}}</h4>
                <p class="user-role">{{userMeta.role_details?.name || '-'}}</p>
                <p class="user-email">{{userMeta.user_profile?.email || '-'}}</p>
              </div>
            </div>
            <div class="menu-options">
              <div class="menu-item" (click)="viewProfile(); dashboardLogoutPanel.hide()" role="menuitem" tabindex="0">
                <em class="pi pi-user menu-icon"></em>
                <span>View Profile</span>
              </div>
              <hr />
              <div class="menu-item logout-item" (click)="signOut(); dashboardLogoutPanel.hide()" role="menuitem" tabindex="0">
                <em class="pi pi-sign-out menu-icon"></em>
                <span>Logout</span>
              </div>
            </div>
          </div>
        </p-popover>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="dashboard-main">

    <!-- OVERVIEW SECTION -->
    <div class="dashboard-section">
      <h2 class="section-header">Activity Overview</h2>

      <!-- EVENTS -->
      <p class="subsection-label">EVENTS</p>
      <div class="metrics-row">
        <!-- Skeleton Loading Cards -->
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>

        <!-- Total Events -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Total Events</h3>
            <div class="stat-card-icon">
              <i class="pi pi-calendar" style="color: #3d83f5;"></i>
            </div>
          </div>
          <p class="stat-card-value">{{ eventsData.total_events || 0 }}</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">{{ getTimeFilterLabel() }}</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.total_events)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.total_events > 0" class="trend-arrow" xmlns="http://www.w3.org/2000/svg"
                width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.total_events < 0" class="trend-arrow" xmlns="http://www.w3.org/2000/svg"
                width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.total_events) }}
            </span>
          </div>
        </div>

        <!-- Active Events -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Active Events</h3>
            <div class="stat-card-icon">
              <i class="pi pi-check-circle" style="color: #3d83f5;"></i>
            </div>
          </div>
          <p class="stat-card-value">{{ eventsData.total_active_events || 0 }}</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">Currently active</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.total_active_events)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.total_active_events > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.total_active_events < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.total_active_events) }}
            </span>
          </div>
        </div>

        <!-- Upcoming Events -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Upcoming Events</h3>
            <div class="stat-card-icon">
              <i class="pi pi-calendar-clock" style="color: #3d83f5;"></i>
            </div>
          </div>
          <p class="stat-card-value">{{ eventsData.total_upcoming_events || 0 }}</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">Starts soon</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.total_upcoming_events)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.total_upcoming_events > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.total_upcoming_events < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.total_upcoming_events) }}
            </span>
          </div>
        </div>
      </div>

      <!-- PIPELINE -->
      <p class="subsection-label">Candidates</p>
      <div class="metrics-row">
        <!-- Skeleton Loading Cards -->
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>
        <div class="skeleton-card" *ngIf="isSummaryLoading">
          <div class="skeleton-header">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-icon"></div>
          </div>
          <div class="skeleton skeleton-value"></div>
          <div class="skeleton-footer">
            <div class="skeleton skeleton-description"></div>
            <div class="skeleton skeleton-trend"></div>
          </div>
        </div>

        <!-- Total Candidates -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Total Candidates</h3>
            <div class="stat-card-icon">
              <img src="assets/icons-svg/people.svg" alt="Users">
            </div>
          </div>
          <p class="stat-card-value">{{ formatNumber(eventsData.total_event_candidates) }}</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">{{ getTimeFilterLabel() }}</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.total_event_candidates)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.total_event_candidates > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.total_event_candidates < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.total_event_candidates) }}
            </span>
          </div>
        </div>

        <!-- Candidate in progress -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Candidate in progress</h3>
            <div class="stat-card-icon">
              <i class="pi pi-spinner-dotted" style="color: #3d83f5;"></i>
            </div>
          </div>
          <p class="stat-card-value">{{ formatNumber(eventsData.total_candidates_in_progress) }}</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">Active in funnel</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.total_candidates_in_progress)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.total_candidates_in_progress > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.total_candidates_in_progress < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.total_candidates_in_progress) }}
            </span>
          </div>
        </div>

        <!-- Acceptance Rate -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Acceptance Rate</h3>
            <div class="stat-card-icon">
              <img src="assets/icons-svg/Stages Icon.svg" alt="Acceptance"
                style="filter: brightness(0) saturate(100%) invert(45%) sepia(89%) saturate(2426%) hue-rotate(203deg) brightness(101%) contrast(92%);">
            </div>
          </div>
          <p class="stat-card-value">{{ (eventsData.offer_acceptance_ratio || 0).toFixed(2) }}%</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">Candidate offer acceptance rate</p>
            <span [ngClass]="getTrendClass(eventsData.trends?.offer_acceptance_ratio)" class="trend-badge">
              <svg *ngIf="eventsData.trends?.offer_acceptance_ratio > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.offer_acceptance_ratio < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(eventsData.trends?.offer_acceptance_ratio) }}
            </span>
          </div>
        </div>

        <!-- Time to Hire -->
        <div class="metric-card" *ngIf="!isSummaryLoading">
          <div class="stat-card-header">
            <h3 class="stat-card-title">Time to Hire</h3>
            <div class="stat-card-icon">
              <i class="pi pi-stopwatch" style="color: #3d83f5;"></i>
            </div>
          </div>
          <p class="stat-card-value">{{ eventsData.avg_time_to_hire || 0 }} days</p>
          <div class="stat-card-footer">
            <p class="stat-card-description">Average time to hire a candidate</p>
            <span
              [ngClass]="getTrendClass(eventsData.trends?.avg_time_to_hire !== null && eventsData.trends?.avg_time_to_hire !== undefined ? (eventsData.trends?.avg_time_to_hire < 0 ? Math.abs(eventsData.trends?.avg_time_to_hire) : -eventsData.trends?.avg_time_to_hire) : null)"
              class="trend-badge">
              <svg *ngIf="eventsData.trends?.avg_time_to_hire < 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <svg *ngIf="eventsData.trends?.avg_time_to_hire > 0" class="trend-arrow"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                <polyline points="16 17 22 17 22 11" />
              </svg>
              {{ formatTrend(Math.abs(eventsData.trends?.avg_time_to_hire || 0)) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ACTIVITY TRENDS SECTION -->
    <div class="dashboard-section" #chartsSectionRef>
      <h2 class="section-header">Activity Trends</h2>
      <div class="charts-row-2col">
        <!-- Past 7-Day Activity -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <i class="pi pi-wave-pulse" style="color: #8B5CF6; font-size: 18px;"></i>
                <h3 class="chart-title">Past 7-Day Activity</h3>
              </div>
              <p class="chart-subtitle">{{ getPeakActivitySubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['dailyActivity']"
                (click)="toggleChartSelector('dailyActivity')">
                <i *ngIf="dailyActivityChartType !== 'doughnut'"
                  [class]="'pi ' + getCurrentChartIcon('dailyActivity')"></i>
                <img *ngIf="dailyActivityChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['dailyActivity']">
                <button *ngFor="let option of dailyActivityChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="dailyActivityChartType === option.value"
                  (click)="selectChartType('dailyActivity', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(dailyActivityData, 'daily-activity.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas #dailyActivityChartCanvas
              *ngIf="!isChartsLoading && dailyActivityData && dailyActivityData.length > 0"></canvas>
            <div *ngIf="!isChartsLoading && (!dailyActivityData || dailyActivityData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No activity data available</p>
            </div>
            <div *ngIf="isChartsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>

        <!-- Top Performing Roles -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <i class="pi pi-briefcase" style="color: #8B5CF6; font-size: 18px;"></i>
                <h3 class="chart-title">Top Performing Roles</h3>
              </div>
              <p class="chart-subtitle">{{ getTopRoleSubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['topRoles']"
                (click)="toggleChartSelector('topRoles')">
                <i *ngIf="rolesChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('topRoles')"></i>
                <img *ngIf="rolesChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['topRoles']">
                <button *ngFor="let option of rolesChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="rolesChartType === option.value" (click)="selectChartType('topRoles', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(topPerformingData, 'top-roles.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas #topPerformingChartCanvas
              *ngIf="!isChartsLoading && topPerformingData && topPerformingData.length > 0"></canvas>
            <div *ngIf="!isChartsLoading && (!topPerformingData || topPerformingData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No role data available</p>
            </div>
            <div *ngIf="isChartsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- HIRING FUNNEL SECTION -->
    <div class="dashboard-section" #funnelSectionRef>
      <h2 class="section-header">Hiring Funnel</h2>
      <div class="charts-row-equal">
        <!-- Hiring Funnel -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <i class="pi pi-chart-scatter" style="color: #8B5CF6; font-size: 18px;"></i>
                <h3 class="chart-title">Hiring Funnel</h3>
              </div>
              <p class="chart-subtitle">{{ getFunnelSubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['funnel']"
                (click)="toggleChartSelector('funnel')">
                <i *ngIf="funnelChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('funnel')"></i>
                <img *ngIf="funnelChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['funnel']">
                <button *ngFor="let option of chartTypeOptions; let i = index" class="chart-type-icon"
                  [class.active]="funnelChartType === option.value" (click)="selectChartType('funnel', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(funnelStages, 'hiring-funnel.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas #funnelChartCanvas *ngIf="!isSummaryLoading && funnelStages && funnelStages.length > 0"></canvas>
            <div *ngIf="!isSummaryLoading && (!funnelStages || funnelStages.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No funnel data available</p>
            </div>
            <div *ngIf="isSummaryLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>

        <!-- Dropoff Analysis -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="#8B5CF6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chart-icon">
                  <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                  <polyline points="16 17 22 17 22 11" />
                </svg>
                <h3 class="chart-title">Dropoff Analysis</h3>
              </div>
              <p class="chart-subtitle">{{ getDropoffSubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['dropoff']"
                (click)="toggleChartSelector('dropoff')">
                <i *ngIf="dropoffChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('dropoff')"></i>
                <img *ngIf="dropoffChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['dropoff']">
                <button *ngFor="let option of dropoffChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="dropoffChartType === option.value" (click)="selectChartType('dropoff', option.value)">
                  <i [class]="'pi ' + option.icon"></i>
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(dropoffData, 'dropoff-analysis.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container chart-container-dropoff">
            <div class="dropoff-list"
              *ngIf="!isFunnelLoading && dropoffData && dropoffData.length > 0 && dropoffChartType === 'horizontal'">
              <div class="dropoff-item" *ngFor="let stage of dropoffData">
                <div class="dropoff-header">
                  <span class="dropoff-stage-name">{{ stage.name }}</span>
                </div>
                <div class="dropoff-bar-wrapper">
                  <div class="dropoff-bar-container">
                    <div class="dropoff-bar">
                      <div class="dropoff-bar-segment dropoff-bar-progressed"
                        [style.width.%]="(stage.progressed / stage.entered) * 100">
                        <span *ngIf="stage.progressed > 0" class="dropoff-bar-value">{{ stage.progressed }}</span>
                      </div>
                      <div class="dropoff-bar-segment dropoff-bar-dropped" *ngIf="stage.dropOff > 0"
                        [style.width.%]="(stage.dropOff / stage.entered) * 100">
                        <span class="dropoff-bar-value">{{ stage.dropOff }}</span>
                        <span class="dropoff-percentage-above" *ngIf="stage.dropOff > 0">{{ ((stage.dropOff /
                          stage.entered) *
                          100).toFixed(0) }}% dropped</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropoff-labels-container">
                    <span class="dropoff-label dropoff-label-progressed">Progressed</span>
                    <span class="dropoff-label dropoff-label-dropped" *ngIf="stage.dropOff > 0">Dropped</span>
                  </div>
                </div>
              </div>
            </div>
            <canvas #dropoffChartCanvas
              *ngIf="!isFunnelLoading && dropoffData && dropoffData.length > 0 && dropoffChartType !== 'horizontal'"></canvas>
            <div *ngIf="!isFunnelLoading && (!dropoffData || dropoffData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No dropoff data available</p>
            </div>
            <div *ngIf="isFunnelLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- RECRUITMENT SOURCES SECTION -->
    <div class="dashboard-section" #analyticsSectionRef>
      <h2 class="section-header">Recruitment Sources</h2>
      <div class="charts-row-custom">
        <!-- Campus Statistics -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <img src="assets/icons-svg/Event Details Icon.svg" alt="Chart" class="chart-icon"
                  style="width: 18px; height: 18px; filter: invert(17%) sepia(85%) saturate(7476%) hue-rotate(248deg) brightness(94%) contrast(97%);">
                <h3 class="chart-title">Campus Statistics</h3>
              </div>
              <p class="chart-subtitle">{{ getCampusSubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['campusStats']"
                (click)="toggleChartSelector('campusStats')">
                <i *ngIf="institutionChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('campusStats')"></i>
                <img *ngIf="institutionChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['campusStats']">
                <button *ngFor="let option of institutionChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="institutionChartType === option.value"
                  (click)="selectChartType('campusStats', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(institutionData, 'campus-stats.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container campus-chart-container">
            <!-- Custom Horizontal Bar for Campus Statistics -->
            <div class="campus-list"
              *ngIf="!isChartsLoading && institutionData && institutionData.length > 0 && institutionChartType === 'horizontal'">
              <div class="campus-item" *ngFor="let institution of institutionData"
                [attr.data-institute]="institution.institute_name"
                [attr.data-registrations]="institution.total_registrations"
                [attr.data-offers]="institution.total_offers" [attr.data-events]="institution.event_count">
                <div class="campus-tooltip">
                  <div class="tooltip-title">{{ institution.institute_name }}</div>
                  <div class="tooltip-body">
                    <div class="tooltip-item">
                      <span class="tooltip-label">Registrations:</span>
                      <span class="tooltip-value">{{ institution.total_registrations }}</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="tooltip-label">Offers:</span>
                      <span class="tooltip-value">{{ institution.total_offers }}</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="tooltip-label">Events:</span>
                      <span class="tooltip-value">{{ institution.event_count }}</span>
                    </div>
                  </div>
                </div>
                <div class="campus-abbreviation">{{ getInstitutionAbbreviation(institution.institute_name) }}</div>
                <div class="campus-bar-wrapper">
                  <div class="campus-bar-container">
                    <!-- Registrations Bar -->
                    <div class="campus-bar campus-bar-registrations">
                      <div class="campus-bar-fill"
                        [style.width.%]="getMaxValue() > 0 ? (institution.total_registrations / getMaxValue()) * 100 : 0">
                        <span class="campus-bar-value" *ngIf="institution.total_registrations > 0">{{
                          institution.total_registrations }}</span>
                      </div>
                    </div>
                    <!-- Offers Bar -->
                    <div class="campus-bar campus-bar-offers" *ngIf="institution.total_offers > 0">
                      <div class="campus-bar-fill"
                        [style.width.%]="getMaxValue() > 0 ? (institution.total_offers / getMaxValue()) * 100 : 0">
                        <span class="campus-bar-value">{{ institution.total_offers }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Campus Legend - Always at bottom -->
            <div class="campus-legend"
              *ngIf="!isChartsLoading && institutionData && institutionData.length > 0 && institutionChartType === 'horizontal'">
                <div class="campus-legend-item">
                  <span class="campus-legend-dot" style="background: #6366F1;"></span>
                  <span class="campus-legend-label">Registrations</span>
                </div>
                <div class="campus-legend-item">
                  <span class="campus-legend-dot" style="background: #10B981;"></span>
                  <span class="campus-legend-label">Offers</span>
              </div>
            </div>
            <!-- Table View for Campus Statistics -->
            <div class="campus-table-container"
              *ngIf="!isChartsLoading && institutionData && institutionData.length > 0 && institutionChartType === 'table'">
              <table class="campus-table">
                <thead>
                  <tr>
                    <th class="name-header">College Name</th>
                    <th class="reg-header">Registrations</th>
                    <th class="offer-header">Offers</th>
                    <th class="event-header">Event Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let institution of institutionData; let i = index">
                    <td class="name-col">{{ institution.institute_name }}</td>
                    <td class="value-col reg-col">{{ institution.total_registrations }}</td>
                    <td class="value-col offer-col">{{ institution.total_offers }}</td>
                    <td class="value-col event-col">{{ institution.event_count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <canvas #campusStatsChartCanvas
              *ngIf="!isChartsLoading && institutionData && institutionData.length > 0 && institutionChartType !== 'horizontal' && institutionChartType !== 'table'"></canvas>
            <div *ngIf="!isChartsLoading && (!institutionData || institutionData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No campus data available</p>
            </div>
            <div *ngIf="isChartsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>

        <!-- Event Type Split -->
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <img src="assets/icons-svg/hierarchy.svg" alt="Chart" class="chart-icon"
                  style="width: 18px; height: 18px; filter: invert(17%) sepia(85%) saturate(7476%) hue-rotate(248deg) brightness(94%) contrast(97%);">
                <h3 class="chart-title">Event Type Distribution</h3>
              </div>
              <p class="chart-subtitle">{{ getEventTypeSubtitle() }}</p>
            </div>
            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['eventType']"
                (click)="toggleChartSelector('eventType')">
                <i *ngIf="eventTypeChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('eventType')"></i>
                <img *ngIf="eventTypeChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['eventType']">
                <button *ngFor="let option of eventTypeChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="eventTypeChartType === option.value"
                  (click)="selectChartType('eventType', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(eventTypeData, 'event-type.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container" style="overflow-y: auto; overflow-x: hidden; padding-top: 1rem;">
            <canvas #eventTypeChartCanvas *ngIf="!isChartsLoading && eventTypeData && eventTypeData.length > 0"></canvas>
            <div *ngIf="!isChartsLoading && (!eventTypeData || eventTypeData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No event type data available</p>
            </div>
            <div *ngIf="isChartsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>
        
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <i class="pi pi-link" style="color: #8B5CF6; font-size: 18px;"></i>
                <h3 class="chart-title">Source Performance Rankings</h3>
              </div>
              <p class="chart-subtitle">Top 5 sources driving the most qualified candidates</p>
            </div>

            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['sourcePerformance']"
                (click)="toggleChartSelector('sourcePerformance')">
                <i *ngIf="sourcePerformanceChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('sourcePerformance')"></i>
                <img *ngIf="sourcePerformanceChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['sourcePerformance']">
                <button *ngFor="let option of sourcePerformanceChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="sourcePerformanceChartType === option.value"
                  (click)="selectChartType('sourcePerformance', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(sourcePerformanceData, 'source-performance.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container" style="overflow-y: auto; overflow-x: hidden; padding-top: 1rem;">
            <canvas #sourcePerformanceChartCanvas *ngIf="!isAnalyticsLoading && sourcePerformanceData && sourcePerformanceData.length > 0"></canvas>
            <div *ngIf="!isAnalyticsLoading && (!sourcePerformanceData || sourcePerformanceData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No source performance data available</p>
            </div>
            <div *ngIf="isAnalyticsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>
        
        <div class="chart-card">
          <div class="chart-header">
            <div class="chart-title-section">
              <div class="chart-title-row">
                <i class="pi pi-users" style="color: #8B5CF6; font-size: 18px;"></i>
                <h3 class="chart-title">Gender Distribution</h3>
              </div>
              <p class="chart-subtitle">A snapshot of gender diversity among candidates</p>
            </div>

            <div class="chart-controls">
              <!-- Chart Selector Icon -->
              <button class="chart-selector-trigger" [class.active]="showChartSelector['genderBasedPerformance']"
                (click)="toggleChartSelector('genderBasedPerformance')">
                <i *ngIf="genderBasedPerformanceChartType !== 'doughnut'" [class]="'pi ' + getCurrentChartIcon('genderBasedPerformance')"></i>
                <img *ngIf="genderBasedPerformanceChartType === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                  class="donut-icon-trigger">
              </button>

              <!-- Floating Chart Selector Panel -->
              <div class="chart-selector-panel" *ngIf="showChartSelector['genderBasedPerformance']">
                <button *ngFor="let option of genderBasedPerformanceChartOptions; let i = index" class="chart-type-icon"
                  [class.active]="genderBasedPerformanceChartType === option.value"
                  (click)="selectChartType('genderBasedPerformance', option.value)">
                  <i *ngIf="option.value !== 'doughnut'" [class]="'pi ' + option.icon"></i>
                  <img *ngIf="option.value === 'doughnut'" src="assets/icons-svg/donut.svg" alt="Donut"
                    class="donut-icon">
                  <span class="tooltip">{{ option.label }}</span>
                </button>
              </div>

              <button class="export-btn" (click)="exportToCSV(genderBasedPerformanceData, 'gender-based-performance.csv')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="chart-container" style="overflow-y: auto; overflow-x: hidden; padding-top: 1rem;">
            <canvas #genderBasedPerformanceChartCanvas *ngIf="!isAnalyticsLoading && genderBasedPerformanceData && genderBasedPerformanceData.length > 0"></canvas>
            <div *ngIf="!isAnalyticsLoading && (!genderBasedPerformanceData || genderBasedPerformanceData.length === 0)" class="no-data">
              <i class="pi pi-inbox"></i>
              <p>No gender based performance data available</p>
            </div>
            <div *ngIf="isAnalyticsLoading" class="skeleton skeleton-chart"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>